// extracted by mini-css-extract-plugin
export default {"container":"ProductAddRemoveController_container__NIQPA","qty":"ProductAddRemoveController_qty__BYikH"};